var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72917 6.83333C5.16741 6.83333 6.33333 5.66741 6.33333 4.22917C6.33333 2.79093 5.16741 1.625 3.72917 1.625C2.29093 1.625 1.125 2.79093 1.125 4.22917C1.125 5.66741 2.29093 6.83333 3.72917 6.83333ZM3.72917 6.83333V15.1667M3.72917 15.1667C2.29093 15.1667 1.125 16.3326 1.125 17.7708C1.125 19.2091 2.29093 20.375 3.72917 20.375C5.16741 20.375 6.33333 19.2091 6.33333 17.7708C6.33333 16.3326 5.16741 15.1667 3.72917 15.1667ZM17.2708 15.1667V7.5625C17.2708 6.39573 17.2708 5.81233 17.0437 5.36669C16.8441 4.97468 16.5253 4.65597 16.1333 4.45624C15.6877 4.22917 15.1043 4.22917 13.9375 4.22917H10.5M17.2708 15.1667C18.7091 15.1667 19.875 16.3326 19.875 17.7708C19.875 19.2091 18.7091 20.375 17.2708 20.375C15.8326 20.375 14.6667 19.2091 14.6667 17.7708C14.6667 16.3326 15.8326 15.1667 17.2708 15.1667ZM10.5 4.22917L13.1042 6.83333M10.5 4.22917L13.1042 1.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.5f5f1c38d3803c0b192758fcdf820d76.svg";
export { ForwardRef as ReactComponent };